import type { Callout } from '@/lib/schemas/db'

import { withUniversalTransitions } from './statusRules'

export type SessionStatus = Callout['status']

/** Canonical order of session statuses (drives transition ordering). */
export const SESSION_STATUS_ORDER: SessionStatus[] = [
  'New',
  'Booked',
  'Started',
  'Ended',
  'Blocked',
  'Review',
  'ReadyToInvoice',
  'Invoiced',
  'Cancelled',
]

const statusTransitions: Partial<Record<SessionStatus, SessionStatus[]>> = {
  New: ['Booked', 'Cancelled'],
  Booked: ['Started', 'Cancelled'],
  Started: ['Ended', 'ReadyToInvoice', 'Cancelled'],
  Ended: ['Review', 'ReadyToInvoice', 'Cancelled'],
  Review: ['Started', 'ReadyToInvoice', 'Cancelled'],
  ReadyToInvoice: ['Invoiced', 'Review', 'Cancelled'],
  Invoiced: ['Review'],
  Cancelled: ['Booked'],
}

export function getAllowedSessionStatusTransitions(
  currentStatus: SessionStatus,
): SessionStatus[] {
  return withUniversalTransitions(currentStatus, statusTransitions[currentStatus] ?? [], {
    order: SESSION_STATUS_ORDER,
    initial: 'New',
  })
}

export function assertSessionStatusChangeAllowed(
  currentStatus: SessionStatus,
  nextStatus: SessionStatus,
) {
  const allowed = getAllowedSessionStatusTransitions(currentStatus)
  if (!allowed.includes(nextStatus)) {
    throw new Error(
      `Cannot move Session from ${currentStatus} to ${nextStatus}`,
    )
  }
}
